var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('let-it-snow',_vm._b({staticClass:"pointer-events-none",attrs:{"show":_vm.show}},'let-it-snow',_vm.snowConf,false))}
var staticRenderFns = []

export { render, staticRenderFns }